import { css } from '@emotion/react'

import * as styles from '@twistopayments/design-system/styles'

export const root = css`
  text-align: center;
  max-width: 100%;
  direction: ltr;
`

export const error = css`
  animation: ${styles.animations.errorShake.name} ${styles.duration.complex}ms
    linear;
  ${styles.animations.errorShake.definition}
`

export const label = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${styles.fontSize.xxl};
  cursor: text;
`

export const input = css`
  /* Prevents zooming on iOS devices even for visually hidden input */
  font-size: 16px;

  /* Hide blinking blue caret for iOS mobile devices */
  caret-color: transparent;

  ${styles.hideVisually()}

  text-align: center;
`
